module.exports = __webpack_public_path__ + "static/img/print-2.b1c38a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CloudQuickPrinting/print-2.png
// module id = 3M12
// module chunks = 10